var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useForm } from "react-hook-form";
import { useKushkiJsContext } from "../../../context/useKushkiJsContext";
import { useCheckoutContext, } from "../../../context/useCheckoutContext";
import { useEffect, useState } from "react";
import { PaymentMethodsEnum } from "../../../shared/constants/PaymentMethodEnum";
import { isEmpty } from "lodash";
export var useCheckoutTransferPseState = function () {
    var form = useForm({
        shouldUnregister: false,
    });
    var _a = useState(false), termsModal = _a[0], setTermsModal = _a[1];
    var _b = useState(), bankList = _b[0], setBankList = _b[1];
    var _c = useKushkiJsContext(), requestTransferToken = _c.requestTransferToken, requestBankList = _c.requestBankList;
    var _d = useCheckoutContext(), handlers = _d.handlers, amount = _d.amount, emailKpay = _d.emailKpay, kpaySelected = _d.kpaySelected, currency = _d.currency, kpayEnable = _d.kpayEnable;
    var getBankList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bankListResponse, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    handlers.setCheckoutLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, requestBankList()];
                case 2:
                    bankListResponse = _a.sent();
                    setBankList(bankListResponse);
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    setBankList(undefined);
                    return [3 /*break*/, 5];
                case 4:
                    handlers.setCheckoutLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleTermsModal = function () {
        if (!termsModal)
            setTermsModal(true);
        else
            setTermsModal(false);
    };
    var setBankId = function (bankId) {
        var bank_name = "";
        if (bankList && bankList.length > 0 && bankId) {
            var bank = bankList.find(function (bank) { return bank.code === bankId; });
            bank_name = bank ? bank.name : "";
        }
        return bank_name;
    };
    var handleSubmit = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        var bank, documentType, documentNumber, name_1, urlParams, tokenResponse, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    bank = formData.bank, documentType = formData.documentType, documentNumber = formData.documentNumber, name_1 = formData.name;
                    urlParams = {
                        bank: bank,
                        bankName: setBankId(formData.bank),
                        currency: currency,
                        documentNumber: documentNumber,
                        documentType: documentType,
                        kpayDataSaved: kpayEnable,
                        name: name_1,
                        paymentMethod: PaymentMethodsEnum.TRANSFER_PSE,
                        totalValue: amount.total.toString(),
                    };
                    handlers.setTokenRequestLoading(true);
                    if (kpayEnable && formData.email)
                        handlers.setEmailKpay(formData.email);
                    return [4 /*yield*/, requestTransferToken({
                            amount: amount.amount,
                            bankId: formData.bank,
                            callbackUrl: handlers.buildCallbackUrl(urlParams),
                            currency: "COP",
                            documentNumber: formData.documentNumber,
                            documentType: formData.documentType,
                            email: isEmpty(emailKpay) ? formData.email : emailKpay,
                            name: formData.name,
                            userType: formData.personType,
                        })];
                case 1:
                    tokenResponse = _a.sent();
                    handlers.closeErrorNotification();
                    handlers.setCheckoutToken({
                        contactDetails: { name: formData.name },
                        paymentMethod: PaymentMethodsEnum.TRANSFER,
                        token: tokenResponse.token,
                    });
                    return [3 /*break*/, 4];
                case 2:
                    e_2 = _a.sent();
                    handlers.showErrorNotification(e_2);
                    console.error(e_2);
                    return [3 /*break*/, 4];
                case 3:
                    handlers.setTokenRequestLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getBankList();
    }, []);
    return {
        bankList: bankList,
        emailKpay: emailKpay,
        form: form,
        handleKpayEnable: handlers.setKpayEnable,
        handleSubmit: handleSubmit,
        handleTermsModal: handleTermsModal,
        kpaySelected: kpaySelected,
        termsModal: termsModal,
    };
};
